/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppVersion { 
    id?: number;
    uuid?: string;
    created?: string;
    version?: string;
    current?: boolean;
    mandatory?: boolean;
    deviceType?: AppVersion.DeviceTypeEnum;
}
export namespace AppVersion {
    export type DeviceTypeEnum = 'IOS' | 'ANDROID';
    export const DeviceTypeEnum = {
        Ios: 'IOS' as DeviceTypeEnum,
        Android: 'ANDROID' as DeviceTypeEnum
    };
}


